import { formatCurrency } from '@/lib/format'

export const INVOICE_FRACTION_DIGITS = 2

export const invoiceTabThClass =
  'h-10 border-b border-border bg-[#f5f5f5] px-3 py-2 text-xs font-semibold normal-case tracking-normal text-[#757575]'

export function formatInvoiceAmount(value: number) {
  return formatCurrency(value, 'EUR', INVOICE_FRACTION_DIGITS)
}
